const checkM11Section = (section, m11IssuesList, validationCheckState) => {
    if (!section || !section.code) {
        m11IssuesList.push("Uncoded section detected. Add section.code detail.");
        return;
    }
    if (!validationCheckState) {
        return;
    }
    let sectionCode = section.code.coding?.[0]?.code || section.code.text;
    switch (sectionCode) {
        case "C218514":
            //Steps 8, 9, 10, 15, 16, 17, 18           
            if (validationCheckState.step18numberFailed) {
                if (validationCheckState.resultCheckSection1Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '1 PROTOCOL SUMMARY' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1Text === "FAILED") {
                    m11IssuesList.push("Section 1 PROTOCOL SUMMARY should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection11Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '1.1 Protocol Synopsis' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection11Text === "FAILED") {
                    m11IssuesList.push("Section 1.1 Protocol Synopsis should not have text. Enter data in subsections instead.");
                }
            }
            if (validationCheckState.step15numberFailed) {
                if (validationCheckState.resultCheckSection111Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's first subsection title must be '1.1.1 Primary and Secondary Objectives and Estimands' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection111Content === "FAILED") {
                    m11IssuesList.push("Section 1.1.1 Primary and Secondary Objectives and Estimands is required. Enter data.");
                }
            }
            if (validationCheckState.step16numberFailed) {
                if (validationCheckState.resultCheckSection112Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's second subsection title must be '1.1.2 Overall Design' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection112Content === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Overall Design is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection112ContentOpening === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Key aspects of the trial design are summarised below.'");
                }
                if (validationCheckState.resultCheckSection112ContentIntervention === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Intervention:'");
                }
                if (validationCheckState.resultCheckSection112ContentInterventionModel === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Intervention Model:'");
                }
                if (validationCheckState.resultCheckSection112ContentPopulationType === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Population Type:'");
                }
                if (validationCheckState.resultCheckSection112ContentControlType === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Control Type:'");
                }
                if (validationCheckState.resultCheckSection112ContentDiagnosis === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Population Diagnosis or Condition:'");
                }
                if (validationCheckState.resultCheckSection112ContentControlDescription === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Control Description:'");
                }
                if (validationCheckState.resultCheckSection112ContentPopulationAge === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Population Age:'");
                }
                if (validationCheckState.resultCheckSection112ContentMinimum === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Minimum:'");
                }
                if (validationCheckState.resultCheckSection112ContentMaximum === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Maximum:'");
                }
                if (validationCheckState.resultCheckSection112ContentInterventionAssignmentMethod === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Intervention Assignment Method:'");
                }
                if (validationCheckState.resultCheckSection112ContentStratification === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Stratification'");
                }
                if (validationCheckState.resultCheckSection112ContentSite === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Site Distribution and Geographic Scope:'");
                }
                if (validationCheckState.resultCheckSection112ContentMasterProtocol === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Master Protocol:'");
                }
                if (validationCheckState.resultCheckSection112ContentDrugDevice === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Drug/Device Combination Product Indicator:'");
                }
                if (validationCheckState.resultCheckSection112ContentAdaptive === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Adaptive Trial Design:'");
                }
            }
            if (validationCheckState.step17numberFailed) {
                if (validationCheckState.resultCheckSection112NumberOfArms === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Number of Arms:'");
                }
                if (validationCheckState.resultCheckSection112NumberOfArmsContent === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Number of Arms must have content");
                }
                if (validationCheckState.resultCheckSection112TrialBlindSchema === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Trial Blind Schema:'");
                }
                if (validationCheckState.resultCheckSection112TrialBlindSchemaContent === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Trial Blind Schema must have content");
                }
                if (validationCheckState.resultCheckSection112BlindedRoles === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Blinded roles: The following roles indicated will not be made aware of the treatment group assignment during the trial:'");
                }
                if (validationCheckState.resultCheckSection112BlindedRolesContent === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Blinded Roles must have content");
                }
                if (validationCheckState.resultCheckSection112NumberOfParticipants === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Number of Participants:'");
                }
                if (validationCheckState.resultCheckSection112NumberOfParticipantsContent === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Number of Participants must have content which includes 'participants will be'");
                }
                if (validationCheckState.resultCheckSection112Duration === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Duration:'");
                }
                if (validationCheckState.resultCheckSection112DurationContentIntervention === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Duration content must include 'Total planned duration of trial intervention for each participant:'");
                }
                if (validationCheckState.resultCheckSection112DurationContentParticipation === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Duration content must include 'Total planned duration of trial participation for each participant:'");
                }
                if (validationCheckState.resultCheckSection112Committees === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 content must include 'Committees:'");
                }
                if (validationCheckState.resultCheckSection112CommitteesContent === "FAILED") {
                    m11IssuesList.push("Section 1.1.2 Committees content must include 'Independent Committees:'");
                }
            }
            if (validationCheckState.step18numberFailed) {
                if (validationCheckState.resultCheckSection12Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '1.2 Trial Schema' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection12Content === "FAILED") {
                    m11IssuesList.push("Section 1.2 Trial Schema is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection13Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '1.3 Schedule of Activities' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection13Content === "FAILED") {
                    m11IssuesList.push("Section 1.3 Schedule of Activities is required. Enter data.");
                }
            }
            break;
        case "C218520":
            //Step 19
            if (validationCheckState.step19numberFailed) {
                if (validationCheckState.resultCheckSection2Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '2 INTRODUCTION' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection2Text === "FAILED") {
                    m11IssuesList.push("Section 2 INTRODUCTION should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection21Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '2.1 Purpose of Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection21Content === "FAILED") {
                    m11IssuesList.push("Section 2.1 Purpose of Trial is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection22Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '2.2 Assessment of Risks and Benefits' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection22Content === "FAILED") {
                    m11IssuesList.push("Section 2.2 Assessment of Risks and Benefits must either contain content or contain 3 subsections with content and fixed section headings.");
                }
                if (validationCheckState.resultCheckSection221Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's first subsection title must be '2.2.1 Risk Summary and Mitigation Strategy' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection221Content === "FAILED") {
                    m11IssuesList.push("If present, Section 2.2.1 Risk Summary and Mitigation Strategy should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection222Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's second subsection title must be '2.2.2 Benefit Summary' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection222Content === "FAILED") {
                    m11IssuesList.push("If present, Section 2.2.2 Benefit Summary should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection223Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's third subsection title must be '2.2.3 Overall Risk-Benefit Assessment' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection223Content === "FAILED") {
                    m11IssuesList.push("If present, Section 2.2.3 Overall Risk-Benefit Assessment should have content. Enter data or remove the section.");
                }
            }
            break;
        case "C218526":
            //Steps 8, 9, 10, 11, 12
            if (validationCheckState.step12numberFailed) {
                if (validationCheckState.resultCheckSection3Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '3 TRIAL OBJECTIVES AND ASSOCIATED ESTIMANDS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection3Text === "FAILED") {
                    m11IssuesList.push("Section 3 TRIAL OBJECTIVES AND ASSOCIATED ESTIMANDS should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection31Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '3.1 Primary Objective(s) and Associated Estimand(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection31Text === "FAILED") {
                    m11IssuesList.push("Section 3.1 Primary Objective(s) and Associated Estimand(s) should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection311Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's first subsection title must be '3.1.1 Primary Objective 1' or '3.1.1 Primary Objective' if only one primary objective, so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection311Content === "FAILED") {
                    m11IssuesList.push("Section 3.1.1 Primary Objective 1 is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection311ContentEstimandCharacteristic === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.1 Primary Objective 1 content must include 'Estimand Characteristic'.");
                }
                if (validationCheckState.resultCheckSection311ContentDescription === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.1 Primary Objective 1 content must include 'Description'.");
                }
                if (validationCheckState.resultCheckSection311ContentEndpoint === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.1 Primary Objective 1 content must include 'Endpoint'.");
                }
                if (validationCheckState.resultCheckSection31XHeading === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.X heading must be 'Primary Objective X' or 'Primary Objective' if only one exploratory objective. Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection31XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.X Primary Objective X must have content.");
                }
                if (validationCheckState.resultCheckSection31XContentEstimandCharacteristic === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.X Primary Objective X content must include 'Estimand Characteristic'.");
                }
                if (validationCheckState.resultCheckSection31XContentDescription === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.X Primary Objective X content must include 'Description'.");
                }
                if (validationCheckState.resultCheckSection31XContentEndpoint === "FAILED") {
                    m11IssuesList.push("If present, Section 3.1.X Primary Objective X content must include 'Endpoint'.");
                }
                if (validationCheckState.resultCheckSection32Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '3.2 Secondary Objective(s) and Associated Estimand(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection32Content === "FAILED") {
                    m11IssuesList.push("Section 3.2 Secondary Objective(s) and Associated Estimand(s) must either contain 'Not applicable' or contain subsections starting with '3.2.1 Secondary Objective 1'.");
                }
                if (validationCheckState.resultCheckSection32XHeading === "FAILED") {
                    m11IssuesList.push("If present, Section 3.2.X heading must be 'Secondary Objective X' or 'Secondary Objective' if only one exploratory objective. Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection32XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 3.2.X Secondary Objective X must have content.");
                }
                if (validationCheckState.resultCheckSection32XContentEstimandCharacteristic === "FAILED") {
                    m11IssuesList.push("If present, Section 3.2.X Secondary Objective X content must include 'Estimand Characteristic'.");
                }
                if (validationCheckState.resultCheckSection32XContentDescription === "FAILED") {
                    m11IssuesList.push("If present, Section 3.2.X Secondary Objective X content must include 'Description'.");
                }
                if (validationCheckState.resultCheckSection32XContentEndpoint === "FAILED") {
                    m11IssuesList.push("If present, Section 3.2.X Secondary Objective X content must include 'Endpoint'.");
                }

                if (validationCheckState.resultCheckSection33Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '3.3 Exploratory Objective(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection33Content === "FAILED") {
                    m11IssuesList.push("Section 3.3 Exploratory Objective(s) must either contain 'Not applicable' or contain content or contain subsections starting with '3.3.1 Exploratory Objective'.");
                }
                if (validationCheckState.resultCheckSection33XHeading === "FAILED") {
                    m11IssuesList.push("If present, Section 3.3.X heading must be 'Exploratory Objective X' or 'Exploratory Objective' if only one exploratory objective. Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection33XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 3.3.X Exploratory Objective X must have content.");
                }
                if (validationCheckState.resultCheckSection33XContentEstimandCharacteristic === "FAILED") {
                    m11IssuesList.push("If present, Section 3.3.X Exploratory Objective X content must include 'Estimand Characteristic'.");
                }
                if (validationCheckState.resultCheckSection33XContentDescription === "FAILED") {
                    m11IssuesList.push("If present, Section 3.3.X Exploratory Objective X content must include 'Description'.");
                }
                if (validationCheckState.resultCheckSection33XContentEndpoint === "FAILED") {
                    m11IssuesList.push("If present, Section 3.3.X Exploratory Objective X content must include 'Endpoint'.");
                }
            }
            break;
        case "C218533":
            //Step 20
            if (validationCheckState.step20numberFailed) {
                if (validationCheckState.resultCheckSection4Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '4 TRIAL DESIGN' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection4Text === "FAILED") {
                    m11IssuesList.push("Section 4 TRIAL DESIGN should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection41Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '4.1 Description of Trial Design' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection41Content === "FAILED") {
                    m11IssuesList.push("Section 4.1 Description of Trial Design is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection411Heading === "FAILED") {
                    m11IssuesList.push("If present, the first subsection's first subsection title must be '4.1.1 Stakeholder Input into Design' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection411Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.1.1 Stakeholder Input into Design should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection42Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '4.2 Rationale for Trial Design' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection42Content === "FAILED") {
                    m11IssuesList.push("Section 4.2 Rationale for Trial Design must have content or subheadings. Enter data.")
                }
                if (validationCheckState.resultCheckSection421Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's first subsection title must be '4.2.1 Rationale for Estimand(s)' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection421Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.1 Rationale for Estimand(s) should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection422Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's second subsection title must be '4.2.2 Rationale for Intervention Model' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection422Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.2 Rationale for Intervention Model should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection423Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's third subsection title must be '4.2.3 Rationale for Control Type' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection423Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.3 Rationale for Control Type should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection424Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's fourth subsection title must be '4.2.4 Rationale for Trial Duration' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection424Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.4 Rationale for Trial Duration should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection425Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's fifth subsection title must be '4.2.5 Rationale for Adaptive or Novel Design' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection425Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.5 Rationale for Adaptive or Novel Design should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection426Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's sixth subsection title must be '4.2.6 Rationale for Interim Analysis' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection426Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.6 Rationale for Interim Analysis should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection427Heading === "FAILED") {
                    m11IssuesList.push("If present, the second subsection's seventh subsection title must be '4.2.7 Rationale for Other Trial Design Aspects' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection427Content === "FAILED") {
                    m11IssuesList.push("If present, Section 4.2.7 Rationale for Other Trial Design Aspects should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection43Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '4.3 Trial Stopping Rules' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection43Content === "FAILED") {
                    m11IssuesList.push("Section 4.3 Trial Stopping Rules is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection44Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '4.4 Start of Trial and End of Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection44Content === "FAILED") {
                    m11IssuesList.push("Section 4.4 Start of Trial and End of Trial is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection45Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '4.5 Access to Trial Intervention After End of Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection45Content === "FAILED") {
                    m11IssuesList.push("Section 4.5 Access to Trial Intervention After End of Trial is required. Enter data.");
                }
            }
            break;
        case "C218547":
            //Steps 6, 7
            if (validationCheckState.step07numberFailed) {
                if (validationCheckState.resultCheckSection5Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '5 TRIAL POPULATION' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection5Text === "FAILED") {
                    m11IssuesList.push("Section 5 TRIAL POPULATION should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection51Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '5.1 Description of Trial Population and Rationale' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection51Content === "FAILED") {
                    m11IssuesList.push("Section 5.1 Description of Trial Population and Rationale is required, and must include 'Prospective approval of protocol deviations to recruitment and enrollment criteria, also known as protocol waivers or exemptions, is not permitted.'. Enter data.");
                }
                if (validationCheckState.resultCheckSection52Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '5.2 Inclusion Criteria' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection52Content === "FAILED") {
                    m11IssuesList.push("Section 5.2 Inclusion Criteria is required and must include 'To be eligible to participate in this trial, an individual must meet all the following criteria:'. Enter data.");
                }
                if (validationCheckState.resultCheckSection53Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '5.3 Exclusion Criteria' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection53Content === "FAILED") {
                    m11IssuesList.push("Section 5.3 Exclusion Criteria is required and must include 'An individual who meets any of the following criteria will be excluded from participation in this trial:'. Enter data.");
                }
                if (validationCheckState.resultCheckSection54Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '5.4 Contraception' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection54Text === "FAILED") {
                    m11IssuesList.push("Section 5.4 Contraception has summary text, but No text is intended here (heading only).");
                }
                if (validationCheckState.resultCheckSection541Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection's first subsection title must be '5.4.1 Definitions Related to Childbearing Potential' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection541Content === "FAILED") {
                    m11IssuesList.push("Section 5.4.1 Definitions Related to Childbearing Potential is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection542Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection's second subsection title must be '5.4.2 Contraception Requirements' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection542Content === "FAILED") {
                    m11IssuesList.push("Section 5.4.2 Contraception Requirements is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection55Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '8.7 Lifestyle Restrictions' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection55Content === "FAILED") {
                    m11IssuesList.push("Section 5.5 Lifestyle Restrictions must have content or subheadings.");
                }
                if (validationCheckState.resultCheckSection551Heading === "FAILED") {
                    m11IssuesList.push("If present, the fifth subsection's first subsection title must be '5.5.1 Meals and Dietary Restrictions' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection551Content === "FAILED") {
                    m11IssuesList.push("If present, Section 5.5.1 Meals and Dietary Restrictions should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection552Heading === "FAILED") {
                    m11IssuesList.push("If present, the fifth subsection's second subsection title must be '5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection552Content === "FAILED") {
                    m11IssuesList.push("If present, Section 5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection553Heading === "FAILED") {
                    m11IssuesList.push("If present, the fifth subsection's third subsection title must be '5.5.3 Physical Activity Restrictions' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection553Content === "FAILED") {
                    m11IssuesList.push("If present, Section 5.5.3 Physical Activity Restrictions should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection554Heading === "FAILED") {
                    m11IssuesList.push("If present, the fifth subsection's fourth subsection title must be '5.5.4 Other Activity Restrictions' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection554Content === "FAILED") {
                    m11IssuesList.push("If present, Section 5.5.4 Other Activity Restrictions should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection56Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection title must be '5.6 Screen Failure and Rescreening' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection56Content === "FAILED") {
                    m11IssuesList.push("Section 5.6 Screen Failure and Rescreening is required. Enter data.");
                }
            }
            break;
        case "C218560":
            //Steps 21, 22, 23, 24, 25
            if (validationCheckState.step21numberFailed) {
                if (validationCheckState.resultCheckSection6Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '6 TRIAL INTERVENTION AND CONCOMITANT THERAPY' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection6Content === "FAILED") {
                    m11IssuesList.push("The top section 6 TRIAL INTERVENTION AND CONCOMITANT THERAPY should have content. Enter data.");
                }
            }
            if (validationCheckState.step22numberFailed) {
                if (validationCheckState.resultCheckSection61Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '6.1 Description of Investigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection61Content === "FAILED") {
                    m11IssuesList.push("Section 6.1 Description of Investigational Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection62Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '6.2 Rationale for Investigational Trial Intervention Dose and Regimen' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection62Content === "FAILED") {
                    m11IssuesList.push("Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection63Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '6.3 Investigational Trial Intervention Administration' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection63Content === "FAILED") {
                    m11IssuesList.push("Section 6.3 Investigational Trial Intervention Administration is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection64Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '6.4 Investigational Trial Intervention Dose Modification' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection64Content === "FAILED") {
                    m11IssuesList.push("Section 6.4 Investigational Trial Intervention Dose Modification is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection65Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '6.5 Management of Investigational Trial Intervention Overdose' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection65Content === "FAILED") {
                    m11IssuesList.push("Section 6.5 Management of Investigational Trial Intervention Overdose is required. Enter data.");
                }
            }
            if (validationCheckState.step23numberFailed) {
                if (validationCheckState.resultCheckSection66Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection title must be '6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultChecksection66Text === "FAILED") {
                    m11IssuesList.push("Section 6.6 Preparation, Storage, Handling and Accountability of Investigational Trial Intervention has summary text, but No text is intended here (heading only).");
                }
                if (validationCheckState.resultCheckSection661Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection's first subsection title must be '6.6.1 Preparation of Investigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection661Content === "FAILED") {
                    m11IssuesList.push("Section 6.6.1 Preparation of Investigational Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection662Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection's second subsection title must be '6.6.2 Storage and Handling of Investigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection662Content === "FAILED") {
                    m11IssuesList.push("Section 6.6.2 Storage and Handling of Investigational Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection663Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection's third subsection title must be '6.6.3 Accountability of Investigational Trial Intervention' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection663Content === "FAILED") {
                    m11IssuesList.push("Section 6.6.3 Accountability of Investigational Trial Intervention is required. Enter data.");
                }
            }
            if (validationCheckState.step24numberFailed) {
                if (validationCheckState.resultCheckSection67Heading === "FAILED") {
                    m11IssuesList.push("The seventh subsection title must be '6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection67Text === "FAILED") {
                    m11IssuesList.push("Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding has summary text, but No text is intended here (heading only).");
                }
                if (validationCheckState.resultCheckSection671Heading === "FAILED") {
                    m11IssuesList.push("The sseventh subsection's first subsection title must be '6.7.1 Participant Assignment to Investigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection671Content === "FAILED") {
                    m11IssuesList.push("Section 6.7.1 Participant Assignment to Investigational Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection672Heading === "FAILED") {
                    m11IssuesList.push("If present, the seventh subsection's second subsection title must be '6.7.2 Randomisation' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection672Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.7.2 Randomisation should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection673Heading === "FAILED") {
                    m11IssuesList.push("If present, the seventh subsection's third subsection title must be '6.7.3 Measures to Maintain Blinding' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection673Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.7.3 Measures to Maintain Blinding should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection674Heading === "FAILED") {
                    m11IssuesList.push("If present, the seventh subsection's fourth subsection title must be '6.7.4 Emergency Unblinding at the Site' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection674Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.7.4 Emergency Unblinding at the Site should have content. Enter data or remove the section.");
                }
            }
            if (validationCheckState.step25numberFailed) {
                if (validationCheckState.resultChecksection68Heading === "FAILED") {
                    m11IssuesList.push("The eighth subsection title must be '6.8 Investigational Trial Intervention Adherence' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection68Content === "FAILED") {
                    m11IssuesList.push("Section 6.8 Investigational Trial Intervention Adherence is required. Enter data.");
                }
                if (validationCheckState.resultChecksection69Heading === "FAILED") {
                    m11IssuesList.push("The ninth subsection title must be '6.9 Description of Noninvestigational Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection69Content === "FAILED") {
                    m11IssuesList.push("Section 6.9 Description of Noninvestigational Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection691Heading === "FAILED") {
                    m11IssuesList.push("If present, the ninth subsection's first subsection title must be '6.9.1 Background Trial Intervention' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection691Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.9.1 Background Trial Intervention should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection692Heading === "FAILED") {
                    m11IssuesList.push("If present, the ninth subsection's second subsection title must be '6.9.2 Rescue Therapy' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection692Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.9.2 Rescue Therapy should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection693Heading === "FAILED") {
                    m11IssuesList.push("If present, the ninth subsection's third subsection title must be '6.9.3 Other Noninvestigational Trial Intervention' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection693Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.9.3 Other Noninvestigational Trial Intervention should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultChecksection610Heading === "FAILED") {
                    m11IssuesList.push("The tenth subsection title must be '6.10 Concomitant Therapy' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection610Content === "FAILED") {
                    m11IssuesList.push("Section 6.10 Concomitant Therapy is required. Enter data.");
                }
                if (validationCheckState.resultChecksection6101Heading === "FAILED") {
                    m11IssuesList.push("If present, the tenth subsection's first subsection title must be '6.10.1 Prohibited Concomitant Therapy' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection6101Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.10.1 Prohibited Concomitant Therapy should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultChecksection6102Heading === "FAILED") {
                    m11IssuesList.push("If present, the tenth subsection's second subsection title must be '6.10.2 Permitted Concomitant Therapy' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection6102Content === "FAILED") {
                    m11IssuesList.push("If present, Section 6.10.2 Permitted Concomitant Therapy should have content. Enter data or remove the section.");
                }
            }
            break;
        case "C218583":
            //Step 26
            if (validationCheckState.step26numberFailed) {
                if (validationCheckState.resultCheckSection7Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '7 PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection7Text === "FAILED") {
                    m11IssuesList.push("Section 7 PARTICIPANT DISCONTINUATION OF TRIAL INTERVENTION AND DISCONTINUATION OR WITHDRAWAL FROM TRIAL should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection71Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '7.1 Discontinuation of Trial Intervention for Individual Participants' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection71Text === "FAILED") {
                    m11IssuesList.push("Section 7.1 Discontinuation of Trial Intervention for Individual Participants should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection711Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's first subsection title must be '7.1.1 Permanent Discontinuation of Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection711Content === "FAILED") {
                    m11IssuesList.push("Section 7.1.1 Permanent Discontinuation of Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection712Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's second subsection title must be '7.1.2 Temporary Discontinuation of Trial Intervention' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection712Content === "FAILED") {
                    m11IssuesList.push("Section 7.1.2 Temporary Discontinuation of Trial Intervention is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection713Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's third subsection title must be '7.1.3 Rechallenge' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection713Content === "FAILED") {
                    m11IssuesList.push("Section 7.1.3 Rechallenge is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection72Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '7.2 Participant Discontinuation or Withdrawal from the Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection72Content === "FAILED") {
                    m11IssuesList.push("Section 7.2 Participant Discontinuation or Withdrawal from the Trial is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection73Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '7.3 Management of Loss to Follow-Up' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection73Content === "FAILED") {
                    m11IssuesList.push("Section 7.3 Management of Loss to Follow-Up is required. Enter data.");
                }
            }
            break;
        case "C218590":
            //Steps 27, 28, 29
            if (validationCheckState.step29numberFailed) {
                if (validationCheckState.resultCheckSection8Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '8 TRIAL ASSESSMENTS AND PROCEDURES' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection8Text === "FAILED") {
                    m11IssuesList.push("Section 8 TRIAL ASSESSMENTS AND PROCEDURES should not have text. Enter data in subsections instead.");
                }
            }
            if (validationCheckState.step27numberFailed) {
                if (validationCheckState.resultCheckSection81Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '8.1 Trial Assessments and Procedures Considerations' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection81Content === "FAILED") {
                    m11IssuesList.push("Section 8.1 Trial Assessments and Procedures Considerations is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection82Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '8.2 Screening/Baseline Assessments and Procedures' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection82Content === "FAILED") {
                    m11IssuesList.push("Section 8.2 Screening/Baseline Assessments and Procedures is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection83Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '8.3 Efficacy Assessments and Procedures' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection83Content === "FAILED") {
                    m11IssuesList.push("Section 8.3 Efficacy Assessments and Procedures is required. Enter data.");
                }
            }
            if (validationCheckState.step28numberFailed) {
                if (validationCheckState.resultCheckSection84Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '8.4 Safety Assessments and Procedures' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection84Content === "FAILED") {
                    m11IssuesList.push("Section 8.4 Safety Assessments and Procedures is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection841Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's first subsection title must be '8.4.1 Physical Examination' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection841Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.1 Physical Examination should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection842Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's second subsection title must be '8.4.2 Vital Signs' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection842Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.2 Vital Signs should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection843Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's third subsection title must be '8.4.3 Electrocardiograms' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection843Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.3 Electrocardiograms should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection844Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's fourth subsection title must be '8.4.4 Clinical Laboratory Assessments' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection844Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.4 Clinical Laboratory Assessments should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection845Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's fifth subsection title must be '8.4.5 Pregnancy Testing' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection845Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.5 Pregnancy Testing should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection846Heading === "FAILED") {
                    m11IssuesList.push("If present, the fourth subsection's sixth subsection title must be '8.4.6 Suicidal Ideation and Behaviour Risk Monitoring' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection846Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.4.6 Suicidal Ideation and Behaviour Risk Monitoring should have content. Enter data or remove the section.");
                }
            }
            if (validationCheckState.step29numberFailed) {
                if (validationCheckState.resultCheckSection85Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '8.5 Pharmacokinetics' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection85Content === "FAILED") {
                    m11IssuesList.push("Section 8.5 Pharmacokinetics is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection86Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection title must be '8.6 Biomarkers' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection86Content === "FAILED") {
                    m11IssuesList.push("Section 8.6 Biomarkers has summary text, but No text is intended here (heading only).");
                }
                if (validationCheckState.resultCheckSection861Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection's first subsection title must be '8.6.1 Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection861Content === "FAILED") {
                    m11IssuesList.push("Section 8.6.1 Genetics, Genomics, Pharmacogenetics, and Pharmacogenomics is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection862Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection's second subsection title must be '8.6.2 Pharmacodynamic Biomarkers' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection862Content === "FAILED") {
                    m11IssuesList.push("Section 8.6.2 Pharmacodynamic Biomarkers is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection863Heading === "FAILED") {
                    m11IssuesList.push("If present, the sixth subsection's third subsection title must be '8.6.3 Other Biomarkers' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection863Content === "FAILED") {
                    m11IssuesList.push("If present, Section 8.6.3 Other Biomarkers should have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection87Heading === "FAILED") {
                    m11IssuesList.push("The seventh subsection title must be '8.7 Immunogenicity Assessments' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection87Content === "FAILED") {
                    m11IssuesList.push("Section 8.7 Immunogenicity Assessments is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection88Heading === "FAILED") {
                    m11IssuesList.push("The eighth subsection title must be '8.8 Medical Resource Utilisation and Health Economics' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection88Content === "FAILED") {
                    m11IssuesList.push("Section 8.8 Medical Resource Utilisation and Health Economics is required (but does not apply to COAs). Enter data.");
                }
            }
            break;
        case "C218608":
            //Steps 30, 31, 32
            if (validationCheckState.step32numberFailed) {
                if (validationCheckState.resultCheckSection9Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection9Text === "FAILED") {
                    m11IssuesList.push("Section 9 ADVERSE EVENTS, SERIOUS ADVERSE EVENTS, PRODUCT COMPLAINTS, PREGNANCY AND POSTPARTUM INFORMATION, AND SPECIAL SAFETY SITUATIONS should not have text. Enter data in subsections instead.");
                }
            }
            if (validationCheckState.step30numberFailed) {
                if (validationCheckState.resultCheckSection91Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '9.1 Definitions' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection91Text === "FAILED") {
                    m11IssuesList.push("Section 9.1 Definitions should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection911Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's first subsection title must be '9.1.1 Definitions of Adverse Events' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection911Content === "FAILED") {
                    m11IssuesList.push("Section 9.1.1 Definitions of Adverse Events is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection912Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's second subsection title must be '9.1.2 Definitions of Serious Adverse Events' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection912Content === "FAILED") {
                    m11IssuesList.push("Section 9.1.2 Definitions of Serious Adverse Events is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection913Heading === "FAILED") {
                    m11IssuesList.push("The first subsection's third subsection title must be '9.1.3 Definitions of Product Complaints' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection913Content === "FAILED") {
                    m11IssuesList.push("Section 9.1.3 Definitions of Product Complaints is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection9131Heading === "FAILED") {
                    m11IssuesList.push("If present, the first subsection's third subsection's subsection title must be '9.1.3.1 Definitions of Medical Device Product Complaints' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection9131Content === "FAILED") {
                    m11IssuesList.push("If present, Section 9.1.3.1 Definitions of Medical Device Product Complaints should have content.")
                }
            }
            if (validationCheckState.step31numberFailed) {
                if (validationCheckState.resultCheckSection92Heading === "FAILED") {
                    m11IssuesList.push("Section 9.2 Timing and Procedures for Collection and Reporting is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection921Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's first subsection title must be '9.2.1 Timing' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection921Content === "FAILED") {
                    m11IssuesList.push("Section 9.2.1 Timing is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection922Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's second subsection title must be '9.2.2 Collection Procedures' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection922HeadingIdentification === "FAILED") {
                    m11IssuesList.push("The 9.2.2 Collection Prodecures's first subsection title must be 'Identification' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection922ContentIdentification === "FAILED") {
                    m11IssuesList.push("Section 9.2.2 Collection Procedures Subsection Identification is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection922HeadingSeverity === "FAILED") {
                    m11IssuesList.push("The 9.2.2 Collection Prodecures's second subsection title must be 'Severity' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection922ContentSeverity === "FAILED") {
                    m11IssuesList.push("Section 9.2.2 Collection Procedures Subsection Severity is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection922HeadingCausality === "FAILED") {
                    m11IssuesList.push("The 9.2.2 Collection Prodecures's third subsection title must be 'Causality' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection922ContentCausality === "FAILED") {
                    m11IssuesList.push("Section 9.2.2 Collection Procedures Subsection Causality is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection922HeadingRecording === "FAILED") {
                    m11IssuesList.push("The 9.2.2 Collection Prodecures's fourth subsection title must be 'Recording' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection922ContentRecording === "FAILED") {
                    m11IssuesList.push("Section 9.2.2 Collection Procedures Subsection Recording is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection922HeadingFollowup === "FAILED") {
                    m11IssuesList.push("The 9.2.2 Collection Prodecures's fifth subsection title must be 'Follow-up' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection922ContentFollowup === "FAILED") {
                    m11IssuesList.push("Section 9.2.2 Collection Procedures Subsection Follow-up is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection923Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's third subsection title must be '9.2.3 Reporting' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection923Content === "FAILED") {
                    m11IssuesList.push("Section 9.2.3 Reporting is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection9231Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's third subsection's first subsection title must be '9.2.3.1 Regulatory Reporting Requirements' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection9231Content === "FAILED") {
                    m11IssuesList.push("Section 9.2.3.1 Regulatory Reporting Requirements is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection924Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's fourth subsection title must be '9.2.4 Adverse Events of Special Interest' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection924Content === "FAILED") {
                    m11IssuesList.push("Section 9.2.4 Adverse Events of Special Interest is required. Enter data or enter 'Not Applicable'.");
                }
                if (validationCheckState.resultCheckSection925Heading === "FAILED") {
                    m11IssuesList.push("The second subsection's fifth subsection title must be '9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection925Content === "FAILED") {
                    m11IssuesList.push("Section 9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs is required. Enter data or enter 'Not applicable.'.");
                }
            }
            if (validationCheckState.step32numberFailed) {
                if (validationCheckState.resultCheckSection93Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '9.3 Pregnancy and Postpartum Information' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection93Content === "FAILED") {
                    m11IssuesList.push("Section 9.3 Pregnancy and Postpartum Information has summary text, but No text is intended here (heading only).");
                }
                if (validationCheckState.resultCheckSection931Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 9.3.1 heading must be '9.3.1 Participants Who Become Pregnant During the Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection931Content === "FAILED") {
                    m11IssuesList.push("If present, Section 9.3.1 Participants Who Become Pregnant During the Trial must have content. Enter data or delete the section.");
                }
                if (validationCheckState.resultCheckSection932Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 9.3.2 heading must be '9.3.2 Participants Whose Partners Become Pregnant During the Trial' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection932Content === "FAILED") {
                    m11IssuesList.push("If present, Section 9.3.2 Participants Whose Partners Become Pregnant During the Trial must have content. Enter data or delete the section.");
                }
                if (validationCheckState.resultCheckSection94Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '9.4 Special Safety Situations' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection94Content === "FAILED") {
                    m11IssuesList.push("Section 9.4 Special Safety Situations is required. Enter data.");
                }
            }
            break;
        case "C218625":
            //Steps 8, 9, 10, 11, 33, 34
            if (validationCheckState.step34numberFailed) {
                if (validationCheckState.resultCheckSection10Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '10 STATISTICAL CONSIDERATIONS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection10Text === "FAILED") {
                    m11IssuesList.push("Section 10 STATISTICAL CONSIDERATIONS should not have text. Enter data in subsections instead.");
                }
            }
            if (validationCheckState.step33numberFailed) {
                if (validationCheckState.resultCheckSection101Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '10.1 General Considerations' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection101Content === "FAILED") {
                    m11IssuesList.push("Section 10.1 General Considerations is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection102Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '10.2 Analysis Sets' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection102Content === "FAILED") {
                    m11IssuesList.push("Section 10.2 Analysis Sets is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection103Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '10.3 Analyses of Demographics and Other Baseline Variables' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection103Content === "FAILED") {
                    m11IssuesList.push("Section 10.3 Analyses of Demographics and Other Baseline Variables is required. Enter data.");
                }
            }
            if (validationCheckState.step09numberFailed) {
                if (validationCheckState.resultCheckSection104Heading === "FAILED") {
                    m11IssuesList.push("The fourth subsection title must be '10.4 Analyses Associated with the Primary Objective(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection104Text === "FAILED") {
                    m11IssuesList.push("Section 10.4 Analyses Associated with the Primary Objective(s) does not have text. Enter data in subsections.");
                }
                if (validationCheckState.resultCheckSection104XHeading === "FAILED") {
                    m11IssuesList.push("If present, Section 10.4.X heading must be '10.4.X Primary Objective X' or '10.4.1 Primary Objective' if only one primary objective, so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection104XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 10.4.X Primary Objective X does not have text. Enter data in subsections.");
                }
                if (validationCheckState.resultCheckSection104X1Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.1 heading must be '10.4.X.1 Statistical Analysis Method' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection104X1Content === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.1 Statistical Analysis Method is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection104X2Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.2 heading must be '10.4.X.2 Handling of Data in Relation to Primary Estimand(s)' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection104X2Content === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.2 Handling of Data in Relation to Primary Estimand(s) is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection104X3Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.3 heading must be '10.4.X.3 Handling of Missing Data in Relation to Primary Estimand(s)' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection104X3Content === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X is present, Section 10.4.X.3 Handling of Missing Data in Relation to Primary Estimand(s) is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection104X4Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X.4 is present, Section 10.4.X.4 heading must be '10.4.X.4 Sensitivity Analysis' so Edit Title(s) to fix or remove the section.")
                }
                if (validationCheckState.resultCheckSection104X4Content === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X.4 is present, Section 10.4.X.4 Sensitivity Analysis is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection104X5Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X.5 is present, Section 10.4.X.5 heading must be '10.4.X.5 Supplementary Analysis' so Edit Title(s) to fix or remove the section.")
                }
                if (validationCheckState.resultCheckSection104X5Content === "FAILED") {
                    m11IssuesList.push("If Section 10.4.X.5 is present, Section 10.4.X.5 Supplementary Analysis is required. Enter data.");
                }
            }
            if (validationCheckState.step10numberFailed) {
                if (validationCheckState.resultCheckSection105Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '10.5 Analyses Associated with the Secondary Objective(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection105Content === "FAILED") {
                    m11IssuesList.push("Section 10.5 Analyses Associated with the Secondary Objective(s) is required. Enter data in subsections or enter 'Not applicable.'.");
                }
                if (validationCheckState.resultCheckSection105XHeading === "FAILED") {
                    m11IssuesList.push("If present, Section 10.5.X heading must be '10.5.X Secondary Objective X' or '10.5.1 Secondary Objective' if only one secondary objective, so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection105XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 10.5.X Secondary Objective X does not have text. Enter data in subsections.");
                }
                if (validationCheckState.resultCheckSection105X1Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.1 heading must be '10.5.X.1 Statistical Analysis Method' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection105X1Content === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.1 Statistical Analysis Method is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection105X2Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.2 heading must be '10.5.X.2 Handling of Data in Relation to Secondary Estimand(s)' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection105X2Content === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.2 Handling of Data in Relation to Secondary Estimand(s) is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection105X3Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.3 heading must be '10.5.X.3 Handling of Missing Data in Relation to Secondary Estimand(s)' so Edit Title(s) to fix.")
                }
                if (validationCheckState.resultCheckSection105X3Content === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X is present, Section 10.5.X.3 Handling of Missing Data in Relation to Secondary Estimand(s) is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection105X4Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X.4 is present, Section 10.5.X.4 heading must be '10.5.X.4 Sensitivity Analysis' so Edit Title(s) to fix or remove the section.")
                }
                if (validationCheckState.resultCheckSection105X4Content === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X.4 is present, Section 10.5.X.4 Sensitivity Analysis is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection105X5Heading === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X.5 is present, Section 10.5.X.5 heading must be '10.5.X.5 Supplementary Analysis' so Edit Title(s) to fix or remove the section.")
                }
                if (validationCheckState.resultCheckSection105X5Content === "FAILED") {
                    m11IssuesList.push("If Section 10.5.X.5 is present, Section 10.5.X.5 Supplementary Analysis is required. Enter data.");
                }
            }
            if (validationCheckState.step34numberFailed) {
                if (validationCheckState.resultCheckSection106Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection title must be '10.6 Analyses Associated with the Exploratory Objective(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection106Content === "FAILED") {
                    m11IssuesList.push("Section 10.6 Analyses Associated with the Exploratory Objective(s) is required. Enter data or enter 'Not applicable.'.");
                }
                if (validationCheckState.resultCheckSection107Heading === "FAILED") {
                    m11IssuesList.push("The seventh subsection title must be '10.7 Safety Analyses' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection107Content === "FAILED") {
                    m11IssuesList.push("Section 10.7 Safety Analyses is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection108Heading === "FAILED") {
                    m11IssuesList.push("The eighth subsection title must be '10.8 Other Analyses' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection108Content === "FAILED") {
                    m11IssuesList.push("Section 10.8 Other Analyses is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection109Heading === "FAILED") {
                    m11IssuesList.push("The ninth subsection title must be '10.9 Interim Analyses' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection109Content === "FAILED") {
                    m11IssuesList.push("Section 10.9 Interim Analyses is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection1010Heading === "FAILED") {
                    m11IssuesList.push("The tenth subsection title must be '10.10 Multiplicity Adjustments' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1010Content === "FAILED") {
                    m11IssuesList.push("Section 10.10 Multiplicity Adjustments is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection1011Heading === "FAILED") {
                    m11IssuesList.push("The eleventh subsection title must be '10.11 Sample Size Determination' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1011Content === "FAILED") {
                    m11IssuesList.push("Section 10.11 Sample Size Determination is required. Enter data.");
                }
            }
            break;
        case "C218649":
            //Steps 35, 36, 37
            if (validationCheckState.step37numberFailed) {
                if (validationCheckState.resultCheckSection11Heading === "FAILED") {//TODO check if resultCheckSection11Heading is used for Section 11 and Section 1.1
                    m11IssuesList.push("The top section title must be '11 TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection11Text === "FAILED") {//TODO check if 11 and 1.1 duplicated
                    m11IssuesList.push("Section 11 TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS should not have text. Enter data in subsections instead.");
                }
            }
            if (validationCheckState.step35numberFailed) {
                if (validationCheckState.resultCheckSection111Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '11.1 Regulatory and Ethical Considerations' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection111Content === "FAILED") {
                    m11IssuesList.push("Section 11.1 Regulatory and Ethical Considerations is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection112Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '11.2 Trial Oversight' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection112Content === "FAILED") {
                    m11IssuesList.push("Section 11.2 Trial Oversight is required. Enter data directly or enter data with optional subheadings of 11.2.1 Investigator Responsibilities and 11.2.2 Sponsor Responsibilities.");
                }
                if (validationCheckState.resultCheckSection1121Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 11.2.1 heading is '11.2.1 Investigator Responsibilities' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1121Content === "FAILED") {
                    m11IssuesList.push("If present, Section 11.2.1 Investigator Responsibilities must have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection1122Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 11.2.2 heading is '11.2.2 Sponsor Responsibilities' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1122Content === "FAILED") {
                    m11IssuesList.push("If present, Section 11.2.2 Sponsor Responsibilities must have content. Enter data or remove the section.");
                }
            }
            if (validationCheckState.step36numberFailed) {
                if (validationCheckState.resultCheckSection113Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '11.3 Informed Consent Process' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection113Content === "FAILED") {
                    m11IssuesList.push("Section 11.3 Informed Consent Process should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection1131Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 11.3.1 heading is 'Informed Consent for Rescreening' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection1131Content === "FAILED") {
                    m11IssuesList.push("If present, Section 11.3.1 Informed Consent for Rescreening must have content. Enter data or remove the section.")
                }
                if (validationCheckState.resultCheckSection1132Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 11.3.2 heading is '11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research' so Edit Title to fix.");
                }
                if (validationCheckState.resultCheckSection1132Content === "FAILED") {
                    m11IssuesList.push("If present, Section 11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research must have content. Enter data or remove the section.");
                }
                if (validationCheckState.resultCheckSection114Heading === "FAILED") {
                    m11IssuesList.push("If present, Section 11.3.2 heading is '11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection114Content === "FAILED") {
                    m11IssuesList.push("Section 11.4 Committees is required. Enter data or enter 'Not applicable.'.");
                }
                if (validationCheckState.resultCheckSection115Heading === "FAILED") {
                    m11IssuesList.push("The fifth subsection title must be '11.5 Insurance and Indemnity' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection115Content === "FAILED") {
                    m11IssuesList.push("Section 11.5 Insurance and Indemnity is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection116Heading === "FAILED") {
                    m11IssuesList.push("The sixth subsection title must be '11.6 Risk-Based Quality Management' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection116Content === "FAILED") {
                    m11IssuesList.push("Section 11.6 Risk-Based Quality Management is required. Enter data.");
                }
            }
            if (validationCheckState.step37numberFailed) {
                if (validationCheckState.resultCheckSection117Heading === "FAILED") {
                    m11IssuesList.push("The seventh subsection title must be '11.7 Data Governance' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection117Content === "FAILED") {
                    m11IssuesList.push("Section 11.7 Data Governance is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection118Heading === "FAILED") {
                    m11IssuesList.push("The eighth subsection title must be '11.8 Data Protection' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection118Content === "FAILED") {
                    m11IssuesList.push("Section 11.8 Data Protection is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection119Heading === "FAILED") {
                    m11IssuesList.push("The ninth subsection title must be '11.9 Source Records' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection119Content === "FAILED") {
                    m11IssuesList.push("Section 11.9 Source Records is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection1110Heading === "FAILED") {
                    m11IssuesList.push("The tenth subsection title must be '11.10 Protocol Deviations' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1110Content === "FAILED") {
                    m11IssuesList.push("Section 11.10 Protocol Deviations is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection1111Heading === "FAILED") {
                    m11IssuesList.push("The eleventh subsection title must be '11.11 Early Site Closure' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1111Content === "FAILED") {
                    m11IssuesList.push("Section 11.11 Early Site Closure is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection1112Heading === "FAILED") {
                    m11IssuesList.push("The twelfth subsection title must be '11.12 Data Dissemination' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection1112Content === "FAILED") {
                    m11IssuesList.push("Section 11.12 Data Dissemination is required. Enter data.");
                }
            }
            break;
        case "C218666":
            //Steps 41, 42, 43
            if (validationCheckState.step41numberFailed) {
                if (validationCheckState.resultCheckSection12Heading === "FAILED") {
                    m11IssuesList.push("The top section title must be '12 APPENDIX: SUPPORTING DETAILS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection12Content === "FAILED") {
                    m11IssuesList.push("Section 12 APPENDIX: SUPPORTING DETAILS should not have text. Enter data in subsections instead.");
                }
                if (validationCheckState.resultCheckSection121Heading === "FAILED") {
                    m11IssuesList.push("The first subsection title must be '12.1 Clinical Laboratory Tests' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection121Content === "FAILED") {
                    m11IssuesList.push("Section 12.1 Clinical Laboratory Tests is required. Enter data or enter 'Not Applicable.'.");
                }
                if (validationCheckState.resultCheckSection122Heading === "FAILED") {
                    m11IssuesList.push("The second subsection title must be '12.2 Country/Region-Specific Differences' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection122Content === "FAILED") {
                    m11IssuesList.push("Section 12.2 Country/Region-Specific Differences is required. Enter data or enter 'Not Applicable.'.");
                }
            }
            if (validationCheckState.step42numberFailed) {
                if (validationCheckState.resultCheckSection123Heading === "FAILED") {
                    m11IssuesList.push("The third subsection title must be '12.3 Prior Protocol Amendment(s)' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection123Content === "FAILED") {
                    m11IssuesList.push("Section 12.3 Prior Protocol Amendment(s) is required. Enter data.");
                }
                if (validationCheckState.resultCheckSection123ContentDetail === "FAILED") {
                    m11IssuesList.push("Section 12.3 Prior Protocol Amendment(s) does not contain a valid value. Enter 'This protocol has not been amended.' or 'This is the first protocol amendment.' or 'This protocol has been amended previously. The Protocol Amendment Summary of Changes for the current amendment is located directly before the Table of Contents. Prior amendment(s) to this protocol are listed in the table below, beginning with the most recent.'.");
                }
            }
            if (validationCheckState.step43numberFailed) {
                if (validationCheckState.resultCheckSection12XContent === "FAILED") {
                    m11IssuesList.push("If present, Section 12.X (Additional Appendix) where X is 4 or greater is required to have content. Enter data.");
                }
            }
            break;
        case "C218670":
            //Step 39
            if (validationCheckState.step39numberFailed) {
                if (validationCheckState.resultCheckSection13Heading === "FAILED") {
                    m11IssuesList.push("The section title must be '13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection13Content === "FAILED") {
                    m11IssuesList.push("Section 13 APPENDIX: GLOSSARY OF TERMS AND ABBREVIATIONS is required. Enter data.");
                }
            }
            break;
        case "C218671":
            //Step 40 
            if (validationCheckState.step40numberFailed) {
                if (validationCheckState.resultCheckSection14Heading === "FAILED") {
                    m11IssuesList.push("The section title must be '14 APPENDIX: REFERENCES' so Edit Title to fix.")
                }
                if (validationCheckState.resultCheckSection14Content === "FAILED") {
                    m11IssuesList.push("Section 14 APPENDIX: REFERENCES is required. Enter data.");
                }
            }
            break;
        case "C222769":
            //Steps 1, 2, 3, 4, 5 
            if (validationCheckState.step02numberFailed) {
                if (validationCheckState.resultCheckNctid === "FAILED") {
                    m11IssuesList.push("If NCTID is present, it must follow format of NCTxxxxxxxx where x is a digit.");
                }
                if (validationCheckState.resultCheckCtisid === "FAILED") {
                    m11IssuesList.push("If CTIS ID is present, it must follow format of yyyy-5xxxxx-xx with YYYY corresponding to a year e.g. 2024 and x being an integer.");
                }
                if (validationCheckState.resultCheckWhoNumber === "FAILED") {
                    m11IssuesList.push("If WHO/UTN Number is present, it must follow  format of Uxxxx-xxxx-xxxx where x is a digit.");
                }
            }
            if (validationCheckState.step03numberFailed) {
                if (validationCheckState.resultCheckPhase === "FAILED") {
                    m11IssuesList.push("Trial Phase must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckProductCodeOrNonproprietaryName === "FAILED") {
                    m11IssuesList.push("At least one value must be present for Sponsor's Investigational Product Code or Nonproprietary Name.");
                }
            }
            if (validationCheckState.step05numberFailed) {
                if (validationCheckState.resultCheckTitlePage === "FAILED") {
                    m11IssuesList.push("The Title Page must have content. Enter data.");
                }
                if (validationCheckState.resultCheckFullTitle === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Full Title:'.");
                }
                if (validationCheckState.resultCheckSponsorProtocolIdentifierHeader === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Sponsor Protocol Identifier:'.")
                }
                if (validationCheckState.resultCheckOriginalProtocol === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Original Protocol:'.");
                }
                if (validationCheckState.resultCheckTrialPhase === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Trial Phase:'.");
                }
                if (validationCheckState.resultCheckSponsor === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Sponsor Name and Address:'.");
                }
                if (validationCheckState.resultCheckIdentifiers === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Regulatory or Clinical Trial Identifier(s):'.");
                }
                if (validationCheckState.resultCheckApproval === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Sponsor Approval:'.");
                }
                if (validationCheckState.resultCheckAmendmentDetailsHeading === "FAILED") {
                    m11IssuesList.push("The Title Page must include required heading 'Amendment Details'.");
                }
                if (validationCheckState.resultCheckAmendmentDetailsValue === "FAILED") {
                    m11IssuesList.push("The Title Page must include valid value for Amendment Details.");
                }
            }
            if (validationCheckState.step04numberFailed) {
                if (validationCheckState.resultCheckAmendmentIdentifier === "FAILED") {
                    m11IssuesList.push("If amendment, Amendment Identifier must be present.");
                }
                if (validationCheckState.resultCheckAmendmentScope === "FAILED") {
                    m11IssuesList.push("If amendment, Amendment Scope must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckNotGlobalSpecification === "FAILED") {
                    m11IssuesList.push("If amendment and Amendment Scope is Not Global, a specification of country, region, or site must be present.");
                }
                if (validationCheckState.resultCheckPriorAmendmentIndicator === "FAILED") {
                    m11IssuesList.push("If amendment, First Protocol Amendment or Protocol Previously Amended must be selected.");
                }
                if (validationCheckState.resultCheckApproximateNumber === "FAILED") {
                    m11IssuesList.push("If amendment, approximate number enrolled must be present or approximate percentage must be present (with unit of %).");
                }
                if (validationCheckState.resultCheckAmendmentScopeEnrollmentDefinition === "FAILED") {
                    m11IssuesList.push("If amendment, Amendment Scope Enrollment Definition must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckPrimaryReason === "FAILED") {
                    m11IssuesList.push("If amendment, Primary Reason for Amendment must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckPrimaryReasonOtherExplained === "FAILED") {
                    m11IssuesList.push("If Primary Reason for Amendment is Other, explanation must be provided.");
                }
                if (validationCheckState.resultCheckSecondaryReason === "FAILED") {
                    m11IssuesList.push("If amendment, Secondary Reason for Amendment must be present and match allowed values.");
                }
                if (validationCheckState.resultCheckSecondaryReasonOtherExplained === "FAILED") {
                    m11IssuesList.push("If Secondary Reason for Amendment is Other, explanation must be provided.");
                }
                if (validationCheckState.resultCheckAmendmentSummary === "FAILED") {
                    m11IssuesList.push("If amendment, Amendment Summary must be present.");
                }
                if (validationCheckState.resultCheckSafetyImpact === "FAILED") {
                    m11IssuesList.push("If amendment, response to 'Is this amendment likely to have a substantial impact on the safety or rights of the participants?' must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckSafetyImpactComment === "FAILED") {
                    m11IssuesList.push("If Yes to Substantial Impact on Safety, explanatory text must be provided.");
                }
                if (validationCheckState.resultCheckReliabiltytImpact === "FAILED") {
                    m11IssuesList.push("If amendment, response to 'Is this amendment likely to have a substantial impact on the reliability and robustness of the data generated by the clinical trial?' must be present and match an allowed value.");
                }
                if (validationCheckState.resultCheckReliabiltytImpactComment === "FAILED") {
                    m11IssuesList.push("If Yes to Substantial Impact on Reliability, explanatory text must be provided.");
                }
                if (validationCheckState.resultCheckAmendmentDetail === "FAILED") {
                    m11IssuesList.push("If amendment, Amendment Detail must be provided as text or table.");
                }
                if (validationCheckState.resultCheckAmendmentDetailSectionCode === "FAILED") {
                    m11IssuesList.push("If amendment detail with table, Section # and Name entries must match an allowed value.");
                }
            }
            break;
        default:
            m11IssuesList.push("Unrecognized section detected. Check section.code " + sectionCode);
    }
};

export default checkM11Section;